import React from "react";
import { useStore } from "zustand";

import { navigationStore } from "../../store/navigation";
import { parseSharableLinkId } from "../../utils/api.utils";

export const useInsightIdentifierEffect = (
    identifier: string,
    action: () => Promise<void>,
): void => {
    const rawIdentifier = useStore(
        navigationStore,
        (state) => state.identifier,
    );
    const insightIdentifier = rawIdentifier
        ? parseSharableLinkId(rawIdentifier).identifier
        : undefined;
    React.useEffect(() => {
        if (identifier === insightIdentifier) {
            void action();
        }
    }, [identifier, insightIdentifier]);
};
